import { isMarketConfigured, type ConnectionType } from '@talos/kyoko';
import { useMemo } from 'react';
import { AvailabilityEnum, type AvailabilityCondition } from '../types';

/** Hook wrapper for getMarketConfiguredCondition */
export const useMarketConfiguredCondition = ({
  connectionType,
}: GetMarketConfiguredConditionParams): AvailabilityCondition => {
  return useMemo(() => getMarketConfiguredCondition({ connectionType }), [connectionType]);
};

export interface GetMarketConfiguredConditionParams {
  connectionType: ConnectionType;
}

/**
 * A AvailabilityCondition asserting that the Market.[ConnectionType] is present (defined) and that Market.[ConnectionType].Status
 * is not "Unavailable"
 */
export function getMarketConfiguredCondition({
  connectionType,
}: GetMarketConfiguredConditionParams): AvailabilityCondition {
  return {
    id: 'marketConfigured',
    ready: true,
    condition: market => {
      if (isMarketConfigured(market, connectionType)) {
        return { availability: AvailabilityEnum.Ok };
      }
      return {
        availability: AvailabilityEnum.Disabled,
        render: () => `Market is not configured for connection type ${connectionType}`,
      };
    },
  } satisfies AvailabilityCondition;
}
